<template>
  <main-layout
    customControls
    controlsBg="light"
    :hasControlsBar="true"
    :breadcrumb="getBreadcrumb"
  >
    <div slot="custom-controls-top">
      <div class="controls__filters note">
        <health-week-control
          v-model="selectedDay"
        />
        <health-explorer-controls-user-select
          v-model="selectedUser"
          v-show="!disableUserSelect"
          v-on:hidden="hiddeComp"
          v-on:click="onShowPlan"
        />
      </div>
    </div>

    <div class="container">
      <div v-if="!hasNutritionPlan && !loadingPlan" class="no-plan-banner">
        <font-awesome-icon :icon="icons.warning" />
        {{ $t('health.nutritionalPlan.noPlan') }}
      </div>

      <template v-if="planChecked">
        <grid-row class="margin-top-xl" column-align="center">
          <grid-col col-size="12">
            <div style="display: flex; align-items: center; justify-content: space-between;">
              <h1 class="header-title">
                <chevron @click="$router.back()" />
                {{ $t('health.nutritionalPlan.calendar') }}
              </h1>
              <div style="display: flex; gap: 0.5em;">
                <button v-if="hasNutritionPlan" class="template-plan-btn" @click="showCreateTemplateModal = true">
                  <font-awesome-icon :icon="icons.files" /> {{ $t('health.nutritionalPlanTemplate.saveAsTemplate') || 'Guardar como Plantilla' }}
                </button>
                <button class="template-plan-btn" @click="showTemplateListModal = true">
                  <font-awesome-icon :icon="icons.clone" /> {{ $t('health.nutritionalPlan.templates') }}
                </button>
                <button class="reset-plan-btn" @click="resetPlan">
                  <font-awesome-icon :icon="icons.reset" />
                  {{ $t('health.nutritionalPlan.reset') }}
                </button>
                <button v-if="hasNutritionPlan"
                  @click="confirmAssignPlan"
                  class="update-plan-btn">
                  {{ $t('health.nutritionalPlan.assign28Days') }}
                </button>
                <button v-if="hasNutritionPlan" class="update-plan-btn" @click="updatePlan">
                  {{ $t('health.nutritionalPlan.update') }}
                </button>
              </div>
            </div>
          </grid-col>
        </grid-row>
        <template v-if="hasNutritionPlan">

      <div class="calendar-layout">
        <recipe-detail-modal
          v-if="selectedRecipe"
          :recipe="selectedRecipe"
          @close="onRecipeModalClose"
        />
      <table class="week-table">
        <thead>
        <tr>
          <th></th>
          <th v-for="day in weekDays" :key="day"
              :class="{ 'selected-day': selectedDaySummary && selectedDaySummary.day === day }"
              @click="selectDay(day)"
              style="cursor: pointer;">
            {{ $t(`health.nutritionalPlan.weekDays.${day}`) }}
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="mealType in mealTypes" :key="mealType">
          <td>{{ $t(`health.nutritionalPlan.mealTypes2.${mealType}`) }}
            <div
              v-if="showSummary && selectedDaySummary && selectedDaySummary.byMealType[mealType] && selectedDaySummary.byMealType[mealType].length"
              class="macro-summary macro-summary--inline"
            >
              <div class="macro-summary__item">
                <span class="macro-summary__label">P:</span>
                <span class="macro-summary__percent" style="background: #9765E0">
        {{ mealTypeProteinPercent(selectedDaySummary.byMealType[mealType]) }}%
      </span>
              </div>
              <div class="macro-summary__item">
                <span class="macro-summary__label">HC:</span>
                <span class="macro-summary__percent" style="background: #C4CC52">
        {{ mealTypeCarbsPercent(selectedDaySummary.byMealType[mealType]) }}%
      </span>
              </div>
              <div class="macro-summary__item">
                <span class="macro-summary__label">G:</span>
                <span class="macro-summary__percent" style="background: #00C2BA">
        {{ mealTypeFatPercent(selectedDaySummary.byMealType[mealType]) }}%
      </span>
              </div>
            </div>
          </td>
          <td v-for="day in weekDays" :key="day">
            <div
              v-for="(meal, mealIndex) in getMealsByDayAndType(day, mealType)"
              :key="day + mealType + (meal.recipeId || mealIndex)"
              class="meal-wrapper"
            >
              <div v-if="meal.name" class="meal-actions">
                <font-awesome-icon
                  :icon="icons.trash"
                  class="meal-action-icon meal-action-icon--delete"
                  @click.stop="deleteRecipe(day, mealType, meal.recipeId)"
                />
                <!-- 'change' swaps the whole slot (main + snack) — shown once, on the first recipe. -->
                <font-awesome-icon
                  v-if="mealIndex === 0"
                  :icon="icons.change"
                  class="meal-action-icon meal-action-icon--change"
                  @click.stop="changeRecipe(day, mealType)"
                />
              </div>
              <img
                v-if="meal.imageUrl"
                :src="meal.imageUrl"
                :alt="meal.name"
                class="meal-image"
                style="cursor: pointer;"
                @click="openRecipeDetail(meal, day, mealType)"
              />
              <div
                v-else-if="meal.name"
                class="meal-image meal-image--placeholder"
                style="cursor: pointer;"
                @click="openRecipeDetail(meal, day, mealType)"
              >
                <font-awesome-icon :icon="icons.utensils" />
              </div>


              <div class="meal-info">
                <h3 v-if="meal.name" class="meal-name">{{ meal.name }}</h3>
                <div v-if="meal.items && meal.items.length" class="macros">
                  <span>P: {{ totalMacro(meal.items, 'protein') }} g</span>
                  <span>HC: {{ totalMacro(meal.items, 'carbs') }} g</span>
                  <span>G: {{ totalMacro(meal.items, 'fat') }} g</span>
                  <span> Kcal: {{ totalMacro(meal.items, 'calories') }}</span>
                </div>

              </div>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
        <div v-if="showSummary" class="summary-panel calendar-summary-panel">
          <h2 class="summary-title">{{ $t('health.nutritionalPlan.summary') }}</h2>
          <ingest-macro-distribution-chart
            :ingredients="selectedDaySummary.items"
            :height="180"
            :width="180"
          />
          <div class="macro-summary">
            <div class="macro-summary__item">
              <span class="macro-summary__label">{{ $t('health.summary.protein') }}</span>
              <span class="macro-summary__value">{{ totalMacro(selectedDaySummary.items, 'protein') }}g</span>
              <span class="macro-summary__percent" style="background: #9765E0">{{ summaryProteinPercent() }}%</span>

            </div>
            <div class="macro-summary__item">
              <span class="macro-summary__label">{{ $t('health.summary.carbs') }}</span>
              <span class="macro-summary__value">{{ totalMacro(selectedDaySummary.items, 'carbs') }}g</span>
              <span class="macro-summary__percent" style="background: #C4CC52">{{ summaryCarbsPercent() }}%</span>
            </div>
            <div class="macro-summary__item">
              <span class="macro-summary__label">{{ $t('health.summary.fat') }}</span>
              <span class="macro-summary__value">{{ totalMacro(selectedDaySummary.items, 'fat') }}g</span>
              <span class="macro-summary__percent" style="background: #00C2BA">{{ summaryFatPercent() }}%</span>
            </div>
            <div class="macro-summary__item macro-summary__item--fibre">
              <span class="macro-summary__label">{{ $t('health.summary.fibre') }}</span>
              <span class="macro-summary__value">{{ totalMacro(selectedDaySummary.items, 'fibre') }}g</span>
            </div>
          </div>

        </div>
      </div>

      <div class="add-food-section">
        <div class="add-food-selects">
          <div class="day-pills" role="group" :aria-label="$t('health.nutritionalPlan.selectDay')">
            <button
              v-for="day in weekDays"
              :key="day"
              type="button"
              class="day-pill"
              :class="{ 'day-pill--active': addFoodDays.includes(day) }"
              @click="toggleAddFoodDay(day)">
              {{ $t(`health.nutritionalPlan.weekDaysShort.${day}`) }}
            </button>
          </div>
          <select v-model="addFoodMealType">
            <option value="" disabled>{{ $t('health.nutritionalPlan.selectMeal') }}</option>
            <option v-for="mealType in mealTypes" :key="mealType" :value="mealType">
              {{ $t(`health.nutritionalPlan.mealTypes2.${mealType}`) }}
            </option>
          </select>
          <!-- Only shown when the chosen slot holds more than one recipe. With a single
               recipe there is nothing to choose and the control stays out of the way. -->
          <select v-if="addFoodTargetRecipes.length > 1" v-model="addFoodRecipeId">
            <option :value="null" disabled>{{ $t('health.nutritionalPlan.selectRecipe') }}</option>
            <option v-for="recipe in addFoodTargetRecipes" :key="recipe.id" :value="recipe.id">
              {{ recipe.name }}
            </option>
          </select>
          <button class="add-food-btn" @click="openAddFoodModal">
            + {{ $t('health.nutritionalPlan.addFood') }}
          </button>
          <button class="add-food-btn" @click="openSearchRecipeModal(false)">
            + {{ $t('health.nutritionalPlan.addRecipe') }}
          </button>
          <button class="add-food-btn" @click="openSearchRecipeModal(true)">
            + {{ $t('health.nutritionalPlan.addAnotherRecipe') }}
          </button>
          <button class="add-food-btn" @click="showNotesModal = true">
             + {{ $t('health.NutritionistNotes.addNote') }}
          </button>

        </div>
      </div>

      <add-food-modal
        v-if="showAddFoodModal"
        :foods="availableFoods"
        v-on:input="onFoodSelected"
        v-on:close="showAddFoodModal = false"
      />

      <add-recipe-modal
        v-if="showSearchRecipeModal"
        :recipes="availablePlans"
        :initial-type="addFoodMealType"
        v-on:input="onPlanSelected"
        v-on:close="showSearchRecipeModal = false"
      />

      <create-nutritionist-note-modal
        v-if="showNotesModal"
        :patient-id="selectedUser"
        @saved="saveNote"
        @close="showNotesModal = false"
      />
          <template-list-modal
            v-if="showTemplateListModal"
            @input="onTemplateSelected"
            @close="showTemplateListModal = false"
          />
          <create-template-modal
            v-if="showCreateTemplateModal"
            @save="createTemplate"
            @close="showCreateTemplateModal = false"
          />

      </template>
      </template>
      </div>
  </main-layout>
</template>



<script>

import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';
import HealthExplorerControlsUserSelect from 'BRAND/components/explorer/HealthExplorerControlsUserSelect';
import HealthWeekControl from 'BRAND/components/explorer/HealthWeekControl';
import BtnPill from '@/components/shared/buttons/BtnPill';
import MainLayout from '@/layouts/MainLayout';
import Chevron from '@/components/shared/Chevron';
import selectedPatient from '../../store/selectedPatient';
import IngestMacroDistributionChart from 'BRAND/components/nutritionPlan/IngestMacroDistributionChart';
import AddFoodModal from 'BRAND/components/nutritionPlan/AddFoodModal';
import AddRecipeModal from 'BRAND/components/nutritionPlan/AddRecipeModal';
import RecipeDetailModal from 'BRAND/components/nutritionPlan/RecipeDetailModal';
import TemplateListModal from 'BRAND/components/template/TemplateListModal';
import CreateTemplateModal from  'BRAND/components/template/CreateTemplateModal';
import { faTrashAlt, faSyncAlt, faExclamationTriangle, faUtensils, faRedoAlt, faClone, faCopy} from '@fortawesome/pro-regular-svg-icons';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import CreateNutritionistNoteModal from 'BRAND/components/nutritionPlan/CreateNutritionistNoteModal';
import recipeApi from '../../api/recipe'
import {mapGetters} from "vuex";
import nutritionalPlanApi from '../../api/nutritionalPlan'
import foodApi from '../../api/nutritionPlan'
import templateApi from '../../api/template'

export default {
  name: 'NutritionCalendarTable',
  components: {
    GridRow,
    GridCol,
    Chevron,
    HealthWeekControl,
    HealthExplorerControlsUserSelect,
    BtnPill,
    MainLayout,
    IngestMacroDistributionChart,
    AddFoodModal,
    AddRecipeModal,
    RecipeDetailModal,
    FontAwesomeIcon,
    CreateNutritionistNoteModal,
    TemplateListModal,
    CreateTemplateModal
  },
  props: {
    foods: Array,
    color: String,
    name: String,
    imageUrl: String
  },
  data () {
    const weekPlan = []
    const originalAmounts = {};
    weekPlan.forEach(dayPlan => {
      dayPlan.recipes.forEach(recipe => {
        recipe.items.forEach(item => {
          const key = `${dayPlan.date}_${dayPlan.type}_${item.food_id}`;
          originalAmounts[key] = item.amount;
        });
      });
    });

    return {
      weekPlan,
      originalAmounts,
      selectedDaySummary: "monday",
      showSummary: false,
      selectedUser: null,
      selectedDay: new Date(),
      disableUserSelect: false,
      weekDays: ['monday','tuesday','wednesday','thursday','friday','saturday','sunday'],
      mealTypes: ['Desayuno', 'Almuerzo', 'Comida', 'Merienda', 'Cena'],
      addFoodDay: '',
      addFoodDays: [],
      addFoodMealType: '',
      addFoodRecipeId: null,
      addRecipeAppend: false,
      showAddFoodModal: false,
      availableFoods: [],
      showNotesModal: false,
      showSearchRecipeModal: false,
      showTemplateListModal:false,
      showCreateTemplateModal: false,
      availablePlans: [],
      selectedRecipe: null,
      icons: {
        trash: faTrashAlt,
        change: faSyncAlt,
        warning: faExclamationTriangle,
        utensils: faUtensils,
        reset: faRedoAlt,
        clone: faClone,
        files: faCopy
      },
      originalWeekPlan: [],
      hasNutritionPlan: true,
      loadingPlan: false,
      planChecked: false,

    };
  },
  computed: {
    ...mapGetters([
      'getLanguageCode'
    ]),
    getBreadcrumb() {
      return [
        {link: '/workspace', name: this.$t('menu.workspace')},
        {link: '/calendar', name: this.$t('health.nutritionalPlan.calendar'), disabled: true}
      ];
    },
    startDate() {
      if (!this.selectedDay) return null;
      const date = new Date(this.selectedDay);
      const day = date.getDay();
      const diff = date.getDate() - day + (day === 0 ? -6 : 1);
      const monday = new Date(date.setDate(diff));
      return monday.toISOString().split('T')[0];
    },
    endDate() {
      if (!this.selectedDay) return null;
      const date = new Date(this.selectedDay);
      const day = date.getDay();
      const diff = date.getDate() - day + (day === 0 ? 0 : 7);
      const sunday = new Date(date.setDate(diff));
      return sunday.toISOString().split('T')[0];
    },
    // The recipes sitting in the slot that "+ anadir alimento" would write to. A meal slot
    // can hold more than one recipe (main dish + snack), so the target is not always
    // obvious and the user has to be able to pick.
    addFoodTargetRecipes() {
      if (!this.addFoodDay || !this.addFoodMealType) return [];
      const dateStr = this.getDateOfWeek(this.addFoodDay);
      const dayPlan = this.weekPlan.find(d => d.date === dateStr && d.type === this.addFoodMealType);
      return (dayPlan && dayPlan.recipes) ? dayPlan.recipes : [];
    }

  },
  watch: {
    // Auto-recarga del plan cuando el usuario cambia de semana con los
    // chevrones (o con flechas del teclado). Solo se dispara si ya
    // existe un usuario seleccionado y planChecked es true (es decir,
    // el usuario ya pulso 'Mostrar' al menos una vez en esta sesion).
    // Asi evitamos peticiones automaticas la primera vez que se abre
    // la pagina, manteniendo el flujo explicito inicial.
    //
    // Debounce de 300ms para que si el usuario clica el chevron varias
    // veces seguidas solo se haga una request al final.
    selectedDay() {
      if (!this.selectedUser || !this.planChecked) return;
      if (this._weekChangeTimer) clearTimeout(this._weekChangeTimer);
      this._weekChangeTimer = setTimeout(() => {
        this.loadPlan(this.selectedUser);
      }, 300);
    },
    // The recipe picked for "+ anadir alimento" belongs to one slot; changing the meal
    // (or the day, in toggleAddFoodDay) makes it meaningless, so drop it.
    addFoodMealType() {
      this.addFoodRecipeId = null;
    }
  },
  beforeDestroy() {
    if (this._weekChangeTimer) clearTimeout(this._weekChangeTimer);
  },
  async created(){
    const patientId = this.$route.query.id || selectedPatient.get();
    if (patientId) {
        this.selectedUser = patientId;
        this.loadPlan(this.selectedUser);
    }
    const language = this.getLanguageCode
    this.availablePlans = await recipeApi.getRecipes(this, language);
    this.availableFoods = await foodApi.getFoodList(this, language);
  },
  methods: {
    getDateOfWeek(day) {
      const dayIndex = this.weekDays.indexOf(day);
      const selected = new Date(this.selectedDay);
      const currentDay = selected.getDay();
      const mondayOffset = currentDay === 0 ? -6 : 1 - currentDay;
      const monday = new Date(selected);
      monday.setDate(selected.getDate() + mondayOffset);
      const targetDate = new Date(monday);
      targetDate.setDate(monday.getDate() + dayIndex);
      const yyyy = targetDate.getFullYear();
      const mm = ('0' + (targetDate.getMonth() + 1)).slice(-2);
      const dd = ('0' + targetDate.getDate()).slice(-2);
      return `${yyyy}-${mm}-${dd}`;
    },
    getMealsByDayAndType(day, type) {
      if (!this.weekPlan || !this.weekPlan.length) return [];
      const dateStr = this.getDateOfWeek(day);
      // A meal slot can hold more than one recipe (e.g. a main dish + its snack).
      // Return ONE display object per recipe so the calendar can render them all
      // (stacked) and target actions (edit / delete / add food) at a single recipe
      // via recipeId, instead of only showing recipes[0] and flattening the rest.
      return this.weekPlan
        .filter(item => item.date === dateStr && item.type === type && item.recipes && item.recipes.length > 0)
        .flatMap(item => item.recipes.map(recipe => ({
          recipeId: recipe.id,
          name: recipe.name,
          imageUrl: recipe.imageUrl,
          isCustom: recipe.isCustom || false,
          items: recipe.items || [],
          color: recipe.predictedScoreColor || '#000',
        })));
    },
    async onShowPlan() {
      if (!this.selectedUser) return;
      this.loadPlan(this.selectedUser);

    },
    hiddeComp() {
      this.disableUserSelect = !this.disableUserSelect;
    },
    totalMacro(items, macro) {
      return items.reduce((sum, item) => sum + (item[macro] || 0), 0).toFixed(1);
    },
    summaryTotalKcals() {
      if (!this.selectedDaySummary || !this.selectedDaySummary.items) return 0;
      return parseFloat(this.totalMacro(this.selectedDaySummary.items, 'calories'));
    },
    summaryProteinPercent() {
      const kcals = this.summaryTotalKcals();
      if (!kcals) return 0;
      return ((parseFloat(this.totalMacro(this.selectedDaySummary.items, 'protein')) * 4 / kcals) * 100).toFixed(2);
    },
    summaryCarbsPercent() {
      const kcals = this.summaryTotalKcals();
      if (!kcals) return 0;
      return ((parseFloat(this.totalMacro(this.selectedDaySummary.items, 'carbs')) * 4 / kcals) * 100).toFixed(2);
    },
    summaryFatPercent() {
      const kcals = this.summaryTotalKcals();
      if (!kcals) return 0;
      return ((parseFloat(this.totalMacro(this.selectedDaySummary.items, 'fat')) * 9 / kcals) * 100).toFixed(2);
    },
    selectDay(day) {
      if (this.selectedDaySummary && this.selectedDaySummary.day === day) {
        this.selectedDaySummary = null;
        this.showSummary = false;
        return;
      }

      const allItems = [];
      const byMealType = {};

      this.mealTypes.forEach(mealType => {
        // A slot can hold several recipes (main + snack); aggregate items across all
        // of them so the day/meal summary reflects the full meal, not just the first recipe.
        const meals = this.getMealsByDayAndType(day, mealType);
        const items = meals.reduce((acc, meal) => acc.concat(meal.items || []), []);
        allItems.push(...items);
        byMealType[mealType] = items;
      });

      this.selectedDaySummary = { day, items: allItems, byMealType };
      this.showSummary = true;
    },
    openAddFoodModal() {
      if (!this.addFoodDay || !this.addFoodMealType) {
        alert(this.$t('health.nutritionalPlan.selectDayAndMealType'));
        return;
      }
      const dateStr = this.getDateOfWeek(this.addFoodDay);
      const dayPlan = this.weekPlan.find(d => d.date === dateStr && d.type === this.addFoodMealType);
      // This guard used to check only that the slot existed, while onFoodSelected went on
      // to require a recipe inside it. A slot with a plan row but no recipe therefore
      // opened the picker, took the selection and dropped it at onFoodSelected's own
      // guard without a message. Refuse here, where there is still someone to tell.
      if (!dayPlan || !dayPlan.recipes || !dayPlan.recipes.length) {
        alert(this.$t('health.nutritionalPlan.noLooseFood'));
        return;
      }
      if (!this.getAddFoodTargetRecipe(dayPlan)) {
        alert(this.$t('health.nutritionalPlan.selectRecipeForFood'));
        return;
      }
      this.showAddFoodModal = true;
    },

    // Which recipe of the slot a loose food goes into. One recipe: that one, exactly as
    // before. Several: the one picked in the selector -- never a silent recipes[0], which
    // used to drop the food into whichever recipe happened to be first (89% of Desayuno
    // and Comida slots hold two).
    getAddFoodTargetRecipe(dayPlan) {
      const recipes = (dayPlan && dayPlan.recipes) || [];
      if (recipes.length === 0) return null;
      if (recipes.length === 1) return recipes[0];
      return recipes.find(r => r.id === this.addFoodRecipeId) || null;
    },

    async onFoodSelected(foods) {
      const foodList = Array.isArray(foods) ? foods : [foods];
      if (foodList.length === 0) return;

      const dateStr = this.getDateOfWeek(this.addFoodDay);
      const dayPlan = this.weekPlan.find(d => d.date === dateStr && d.type === this.addFoodMealType);
      const targetRecipe = this.getAddFoodTargetRecipe(dayPlan);
      if (!targetRecipe) return;

      const foodInfos = await Promise.all(
        foodList.map(f => foodApi.getFoodInfo(this, f.food_id, this.getLanguageCode))
      );

      foodList.forEach((food, idx) => {
        const foodInfo = foodInfos[idx];
        const newItem = {
          food_id: food.food_id,
          food_name: foodInfo.food_name,
          amount: foodInfo.portion,
          calories: foodInfo.energy_kJ_value ? parseFloat((foodInfo.energy_kJ_value / 4.184).toFixed(2)) : 0,
          protein: foodInfo.protein_grams_value || 0,
          carbs: foodInfo.carbohydrate_gram_value || 0,
          fat: foodInfo.fat_grams_value || 0,
          fibre: foodInfo.fibre_gram_value || 0
        };

        targetRecipe.items.push(newItem);

        const key = `${dateStr}_${this.addFoodMealType}_${food.food_id}`;
        this.originalAmounts[key] = newItem.amount;
      });

      // Adding a food is an edit. Record it here instead of leaving buildPlanPayload to
      // rediscover it later by diffing against the plan as it was loaded -- see
      // isRecipeEdited for why that diff cannot be trusted on its own.
      this.$set(targetRecipe, 'hasLocalEdits', true);
    },

    onPlanSelected(plan) {
      if (!plan) return;
      if (this.addFoodDays.length === 0) return;

      const buildRecipe = () => ({
        id: plan.id,
        type: plan.type,
        name: plan.name,
        // Deep copy. buildRecipe() runs once per selected day, and handing every day the
        // same items array made those days one shared object: adding an ingredient on
        // Monday made it appear on Tuesday and Wednesday too, and mutated the entry in
        // availablePlans that the picker reads from, so the next insert of that same
        // recipe arrived with the ingredient already in it for the rest of the session.
        items: JSON.parse(JSON.stringify(plan.items || [])),
        imageUrl: plan.imageUrl,
        tags: plan.tags
      });

      const alreadyInMeal = [];

      this.addFoodDays.forEach(day => {
        const dateStr = this.getDateOfWeek(day);
        const existingDayPlan = this.weekPlan.find(d => d.date === dateStr && d.type === this.addFoodMealType);
        if (existingDayPlan) {
          if (this.addRecipeAppend) {
            // The same recipe twice in one meal would leave two cards nothing can tell
            // apart: editing hits whichever comes first, deleting removes both, and the
            // template table rejects the pair outright (uq_template_recipe is keyed on
            // template + day + meal + recipe). Skip that day and say so.
            if (existingDayPlan.recipes.some(r => r.id === plan.id)) {
              alreadyInMeal.push(day);
              return;
            }
            existingDayPlan.recipes.push(buildRecipe());
          } else {
            // Sobrescribe: si ya hay receta(s) ese día/comida, la nueva las reemplaza.
            existingDayPlan.recipes = [buildRecipe()];
          }
        } else {
          this.weekPlan.push({
            date: dateStr,
            type: this.addFoodMealType,
            recipes: [buildRecipe()]
          });
        }
      });

      if (alreadyInMeal.length) {
        alert(this.$t('health.nutritionalPlan.recipeAlreadyInMeal'));
      }
    },
    openRecipeDetail(meal, day, mealType) {
      const dateStr = this.getDateOfWeek(day);
      const dayPlan = this.weekPlan.find(d => d.date === dateStr && d.type === mealType);
      if (!dayPlan || !dayPlan.recipes || !dayPlan.recipes.length) return;

      // Edit the specific recipe the user clicked on (a slot may hold several).
      // meal.recipeId identifies it; fall back to the first recipe if absent.
      const recipe = (meal && meal.recipeId != null
        ? dayPlan.recipes.find(r => r.id === meal.recipeId)
        : null) || dayPlan.recipes[0];
      if (!recipe) return;

      this._editingDayPlan = dayPlan;
      this._editingRecipeId = recipe.id;

      const originalEntry = this.originalWeekPlan
        ? this.originalWeekPlan.find(d => d.date === dateStr && d.type === mealType)
        : null;

      const isEdited = this.isRecipeEdited(recipe, originalEntry) || recipe.isCustom || recipe.custom;

      this.selectedRecipe = {
        ...JSON.parse(JSON.stringify(recipe)),
        type: dayPlan.type,
        isEdited
      };
    },
    onRecipeModalClose(updatedItems) {
      if (this._editingDayPlan && updatedItems) {
        // Write the edited items back to the specific recipe that was opened.
        const target = this._editingRecipeId != null
          ? (this._editingDayPlan.recipes || []).find(r => r.id === this._editingRecipeId)
          : (this._editingDayPlan.recipes || [])[0];
        if (target) {
          target.items = updatedItems;
          // The modal only returns items when it detected a real change, so this is the
          // one moment where "the user edited this recipe" is known for certain. Record
          // it: buildPlanPayload can no longer be left to infer it from the diff alone.
          this.$set(target, 'hasLocalEdits', true);
        }
      }
      this.selectedRecipe = null;
      this._editingDayPlan = null;
      this._editingRecipeId = null;
    },
    deleteRecipe(day, mealType, recipeId) {
      const dateStr = this.getDateOfWeek(day);
      const index = this.weekPlan.findIndex(d => d.date === dateStr && d.type === mealType);
      if (index === -1) return;

      const dayPlan = this.weekPlan[index];
      // Remove only the targeted recipe from the slot (e.g. just the snack). If no
      // recipeId is given, or removing it empties the slot, drop the whole entry.
      if (recipeId != null && Array.isArray(dayPlan.recipes) && dayPlan.recipes.length > 1) {
        dayPlan.recipes = dayPlan.recipes.filter(r => r.id !== recipeId);
        if (dayPlan.recipes.length === 0) {
          this.weekPlan.splice(index, 1);
        }
      } else {
        this.weekPlan.splice(index, 1);
      }
    },
    async changeRecipe(day, mealType) {
      const dateStr = this.getDateOfWeek(day);
      const dayPlan = this.weekPlan.find(d => d.date === dateStr && d.type === mealType);
      if (!dayPlan) return;
      const record = await nutritionalPlanApi.randomRecipe(this, this.selectedUser, dateStr, mealType, this.getLanguageCode);
      if (record && record.recipes && record.recipes.length > 0) {
        const mappedRecipes = record.recipes.map(recipe => ({
          ...recipe,
          isCustom: recipe.isCustom || false,
          items: (recipe.items || []).map(item => ({
            ...item,
            food_name: item.food_name || item.foodName || item.name,
            name: item.name || item.foodName || item.food_name,
            food_id: item.food_id || item.foodId,
            amount: parseFloat(Number(item.amount || 0).toFixed(2)),
            calories: parseFloat(Number(item.calories || 0).toFixed(2)),
            protein: parseFloat(Number(item.protein || 0).toFixed(2)),
            carbs: parseFloat(Number(item.carbs || 0).toFixed(2)),
            fat: parseFloat(Number(item.fat || 0).toFixed(2)),
            fibre: parseFloat(Number(item.fibre || 0).toFixed(2))
          }))
        }));
        this.$set(dayPlan, 'recipes', mappedRecipes);
      }
    },
    // append=false keeps the long-standing behaviour: the chosen recipe replaces
    // whatever is in the meal. append=true adds it alongside, for a main dish plus a
    // dessert. Two buttons rather than a prompt: in a generated plan practically every
    // slot is already occupied, so a confirm would fire on almost every single add.
    openSearchRecipeModal(append = false) {
      this.addRecipeAppend = append === true;
      if (this.addFoodDays.length === 0 || !this.addFoodMealType) {
        alert(this.$t('health.nutritionalPlan.selectDayAndMealType'));
        return;
      }
      // Comportamiento por defecto: sobrescribir si ya hay receta en alguno
      // de los días seleccionados. La acción real ocurre en onPlanSelected.
      this.showSearchRecipeModal = true;
    },
    toggleAddFoodDay(day) {
      const idx = this.addFoodDays.indexOf(day);
      if (idx === -1) {
        this.addFoodDays.push(day);
      } else {
        this.addFoodDays.splice(idx, 1);
      }
      // Mantiene compatibilidad con openAddFoodModal/onFoodSelected (single-day)
      this.addFoodDay = this.addFoodDays.length > 0 ? this.addFoodDays[0] : '';
      this.addFoodRecipeId = null;
    },
    mealTypeProteinPercent(items) {
      const kcals = parseFloat(this.totalMacro(items, 'calories'));
      if (!kcals) return 0;
      return ((parseFloat(this.totalMacro(items, 'protein')) * 4 / kcals) * 100).toFixed(2);
    },
    mealTypeCarbsPercent(items) {
      const kcals = parseFloat(this.totalMacro(items, 'calories'));
      if (!kcals) return 0;
      return ((parseFloat(this.totalMacro(items, 'carbs')) * 4 / kcals) * 100).toFixed(2);
    },
    mealTypeFatPercent(items) {
      const kcals = parseFloat(this.totalMacro(items, 'calories'));
      if (!kcals) return 0;
      return((parseFloat(this.totalMacro(items, 'fat')) * 9 / kcals) * 100).toFixed(2);
    },
    async loadPlan(user) {
      if (!user || !this.startDate || !this.endDate) {
        return;
      }
      this.planChecked = true;
      try {
        const result = await nutritionalPlanApi.getPlans(
          this,
          this.startDate,
          this.endDate,
          this.getLanguageCode,
          user
        );
        this.weekPlan = JSON.parse(JSON.stringify(result));
        this.originalWeekPlan = JSON.parse(JSON.stringify(result));
        this.hasNutritionPlan = true;
      } catch (error) {
        this.loadingPlan = false;
        this.hasNutritionPlan = false;
      }
    },
    async updatePlan() {
      try {
        const planToSave = this.buildPlanPayload();
        await nutritionalPlanApi.savePlan(this, planToSave, this.selectedUser);
        const result = await nutritionalPlanApi.getPlans(
          this, this.startDate, this.endDate, this.getLanguageCode, this.selectedUser
        );
        this.weekPlan = JSON.parse(JSON.stringify(result));
        this.originalWeekPlan = JSON.parse(JSON.stringify(result));
        alert(this.$t('health.nutritionalPlan.updateRecipe'));
      } catch (error) {
        console.error(this.$t('health.nutritionalPlan.errorUpdateRecipe'), error);
        // Without this the failure was console-only: the plan stayed on screen with the
        // edits still in it and nothing said they had not been stored.
        alert(this.$t('health.nutritionalPlan.errorUpdateRecipe'));
      }
    },
    buildPlanPayload() {
      return this.weekDays.flatMap(day =>
        this.mealTypes.map(mealType => {
          const dateStr = this.getDateOfWeek(day);
          const entry = this.weekPlan.find(d => d.date === dateStr && d.type === mealType);
          const originalEntry = this.originalWeekPlan.find(d => d.date === dateStr && d.type === mealType);

          if (!entry) {
            return { date: dateStr, type: mealType, recipes: [] };
          }

          return {
            date: entry.date,
            type: entry.type,
            recipes: entry.recipes
              .filter(recipe => recipe.id)
              .map(recipe => {
                const edited = this.isRecipeEdited(recipe, originalEntry);
                return {
                  id: recipe.id,
                  name: recipe.name,
                  imageUrl: recipe.imageUrl,
                  isCustom: !!(edited || recipe.isCustom || recipe.custom),
                  isNew: edited,
                  items: (recipe.items || [])
                    .filter(item => item != null)
                    .map(item => ({
                      food_id: item.food_id || item.foodId,
                      food_name: item.food_name || item.foodName,
                      amount: item.amount,
                      calories: item.calories,
                      protein: item.protein,
                      fat: item.fat,
                      carbs: item.carbs,
                      fibre: item.fibre
                    }))
                };
              })
          };
        })
      );
    },
    resetPlan() {
      const confirmed = confirm(this.$t('health.nutritionalPlan.confirmReset'));
      if (!confirmed) return;

      this.weekPlan = [];
      this.hasNutritionPlan = true;
    },
    async onTemplateSelected(templateId) {
      this.showTemplateListModal = false;
      if (!templateId) return;

      const confirmed = confirm(this.$t('health.nutritionalPlanTemplate.confirmApply'));

      if (!confirmed) return;

      try {
        const recipesWithItems = await templateApi.getTemplateRecipes(this, templateId,  this.getLanguageCode);

        const newWeekPlan = [];

        if (recipesWithItems && Array.isArray(recipesWithItems)) {
          recipesWithItems.forEach(entry => {
            if (entry.recipes && entry.recipes.length > 0) {
              entry.recipes.forEach(recipe => {
                // entry.date is a day name ("monday"); the objects collected below are keyed
                // by the resolved calendar date. Matching on d.day compared against a field
                // that never exists, so the lookup never hit and every recipe of a meal
                // started its own entry. The calendar renders across entries (it filters) but
                // the save only takes the first one (it finds), so applying a template whose
                // meal holds two recipes showed both and then stored one.
                const dateStr = this.getDateOfWeek(entry.date);
                let dayEntry = newWeekPlan.find(d => d.date === dateStr && d.type === entry.type);

                const recipeObj = {
                  id: recipe.id,
                  type: entry.type,
                  name: recipe.name || 'Receta guardada',
                  items: recipe.items || [],
                  imageUrl: recipe.imageUrl,
                  tags: recipe.tags || [],
                  isCustom: recipe.custom || false
                };

                if (dayEntry) {
                  dayEntry.recipes.push(recipeObj);
                } else {
                  newWeekPlan.push({
                    date: dateStr,
                    type: entry.type,
                    recipes: [recipeObj]
                  });
                }
              });
            }
          });
        }

        this.weekPlan = JSON.parse(JSON.stringify(newWeekPlan));
        this.originalWeekPlan = JSON.parse(JSON.stringify(newWeekPlan));

      } catch (error) {
        console.error(this.$t('health.nutritionalPlanTemplate.errorGettingRecipes'), error);
      }
    },
    async createTemplate(templateData) {
      try {
        const flatRecipes = [];
        this.weekPlan.forEach(dayPlan => {
          if (dayPlan.recipes && dayPlan.recipes.length > 0) {

            const dateObj = new Date(dayPlan.date);
            const jsDay = dateObj.getDay();

            const weekDayIndex = jsDay === 0 ? 6 : jsDay - 1;
            const dayName = this.weekDays[weekDayIndex];

            const originalEntry = this.originalWeekPlan.find(d => d.date === dayPlan.date && d.type === dayPlan.type);

            dayPlan.recipes.forEach(recipe => {
              const edited = this.isRecipeEdited(recipe, originalEntry);

              flatRecipes.push({
                recipeId: recipe.id,
                dayOfWeek: dayName,
                mealType: dayPlan.type,
                isCustom: !!(edited || recipe.isCustom || recipe.custom),
                isNew: edited,
                name: recipe.name,
                items: (recipe.items || []).filter(item => item != null).map(item => ({
                  food_id: item.food_id || item.foodId,
                  food_name: item.food_name || item.foodName,
                  amount: item.amount,
                  calories: item.calories,
                  protein: item.protein,
                  fat: item.fat,
                  carbs: item.carbs,
                  fibre: item.fibre
                }))
              });
            });
          }
        });

        const payload = {
          name: templateData.name,
          description: templateData.description,
          recipes: flatRecipes
        };

        await templateApi.createTemplate(this, payload);

        this.showCreateTemplateModal = false;
        alert(this.$t('health.nutritionalPlanTemplate.confirmSave'));


      } catch (error) {
        console.error(error);
      }
    },
    // Has this recipe's ingredient list been changed since the server last sent it?
    //
    // hasLocalEdits is set the moment an edit actually happens (recipe modal, add-food),
    // and is the signal that can be trusted. The diff against originalWeekPlan is kept as
    // a fallback, but it cannot be the only signal: it looks the recipe up by id inside
    // the slot AS IT WAS LOADED, so a recipe put into that slot during this same session
    // (via "+ anadir receta", or the swap icon) has no baseline at all. areItemsChanged
    // was then never reached, the answer came back "unchanged", isCustom went to the
    // backend as false, and savePlan stored the catalogue id and discarded every edited
    // ingredient -- silently, on a 200. That is the bug the nutritionists worked around
    // by pressing Actualizar after every single recipe, which reloaded the plan and
    // rebuilt the baseline.
    isRecipeEdited(recipe, originalEntry) {
      if (recipe.hasLocalEdits) return true;
      const originalRecipe = originalEntry && originalEntry.recipes
        ? originalEntry.recipes.find(r => r.id === recipe.id)
        : null;
      return !!originalRecipe && this.areItemsChanged(recipe.items, originalRecipe.items);
    },
    areItemsChanged(currentItems = [], originalItems = []) {
      if (currentItems.length !== originalItems.length) return true;
      for (const current of currentItems) {
        const currentId = current.food_id || current.foodId;
        const currentAmount = parseFloat(Number(current.amount || 0).toFixed(2));
        const original = originalItems.find(orig => (orig.food_id || orig.foodId) === currentId);
        if (!original) return true;
        const originalAmount = parseFloat(Number(original.amount || 0).toFixed(2));
        if (currentAmount !== originalAmount) return true;
      }
      return false;
    },
    async confirmAssignPlan() {
      const confirmed = confirm(this.$t('health.nutritionalPlan.confirm28Days'));
      if (!confirmed) return;
      await this.assignPlan();
    },

    async assignPlan() {
      try {
        const planToSave = this.buildPlanPayload();
        await nutritionalPlanApi.saveWeeksPlan(this, planToSave, this.selectedUser);
        alert(this.$t('health.nutritionalPlan.planAssigned'));
      } catch (error) {
        console.error(this.$t('health.nutritionalPlan.errorAssignPlan'), error);
        alert(this.$t('health.nutritionalPlan.errorAssignPlan'));
      }
    }

  }
};


</script>

<style lang="scss" scoped>
@import "../../../../stylesheets/variables";

$accent: #F35647;

.week-table-wrapper {
  overflow-x: auto;
}

.week-table {
  width: 250px;
  height: 250px;
  border-collapse: collapse;
  table-layout: fixed;
}

.week-table th,
.week-table td {
  border: 1px solid $black-light9;
  vertical-align: top;
  padding: 10px;
}

.week-table th {
  background: $disabled;
  text-transform: capitalize;
}

.meal-type {
  font-weight: 600;
  width: 120px;
}

.save-button-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 16px;
}
 .week-table {
   width: 100%;
   table-layout: fixed;
   border-collapse: collapse;
 }

.week-table td,
.week-table th {
  vertical-align: top;
  padding: 0.5em;
}
.week-table td:first-child,
.week-table th:first-child {
  width: 8%;
  white-space: nowrap;
  padding-right: 1em;
}

.meal-image {
  width: 100%;
  aspect-ratio: 16/9;
  object-fit: cover;
  border-radius: 0.5em;
  display: block;
  margin-bottom: 0.5em;
}
.meal-image--placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: $black-light9;
  font-size: 2.5em;
  color: $black-light6;
}

.meal-name {
  font-weight: bold;
  font-size: 0.85em;
  margin: 0 0 0.5em 0;
}
.macros {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25em;
  margin-top: 0.5em;
  font-size: 0.8em;
}

.macros span {
  background: $black-light9;
  border-radius: 12px;
  padding: 2px 8px;
}
.week-table td {
  height: 200px;
  vertical-align: top;
  overflow-y: auto;
}
.calendar-layout {
  display: flex;
  flex-direction: row;
  gap: 1em;
  align-items: flex-start;
}
.macro-summary--inline {
  margin-top: 0.5em;
  font-size: 0.8em;

  .macro-summary__percent {
    font-size: 0.75em;
    padding: 0.1em 0.4em;
  }
}
.week-table {
  flex: 1;
  min-width: 0;
}

.calendar-layout {
  display: flex;
  flex-direction: row;
  gap: 1em;
  align-items: flex-start;
}

.week-table {
  flex: 1;
  min-width: 0;
}

.week-table th.selected-day {
  background-color: $accent;
  color: $white;
}


.summary-panel {
  width: 220px;
  flex-shrink: 0;
  border: 1px solid rgba($black-trans6, 0.25);
  border-radius: 4px;
  padding: 1em;
  position: sticky;
  top: 1em;
}

.summary-title {
  color: $accent;
  font-weight: bold;
  margin: 0 0 1em 0;
  font-size: 1.2em;
}

.add-food-section {
  margin-top: 1em;
  padding: 1em;
  border: 1px solid rgba($black-trans6, 0.25);
  border-radius:$radius;
}

.add-food-selects {
  display: flex;
  gap: 1em;
  align-items: center;
  flex-wrap: wrap;

  select {
    padding: 0.5em;
    border-radius:$radius;
    border: 1px solid rgba($black, 0.25);
  }
}

.day-pills {
  display: flex;
  gap: 0.4em;
  flex-wrap: wrap;
}

.day-pill {
  min-width: 2.2em;
  padding: 0.4em 0.7em;
  border-radius: 999px;
  border: 1px solid rgba($black, 0.25);
  background-color: $white;
  color: $bodycolor;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease;

  &:hover {
    background-color: rgba($accent, 0.1);
    border-color: $accent;
  }

  &--active {
    background-color: $accent;
    color: $white;
    border-color: $accent;

    &:hover {
      background-color: #F46355;
      border-color: #F46355;
    }
  }
}

.add-food-btn {
  background-color: $accent;
  color: $white;
  border: none;
  border-radius: $radius;
  padding: 0.5em 1em;
  cursor: pointer;

  &:hover {
    background-color: #F46355;
  }
}
.meal-actions {
  display: flex;
  gap: 0.5em;
  justify-content: flex-end;
  margin-top: auto;
  padding-top: 0.5em;
}
.update-plan-btn {
  background-color: $accent;
  color: $white;
  border: none;
  border-radius: 4px;
  padding: 0.5em 1em;
  cursor: pointer;

  &:hover {
    background-color: darken($accent, 10%);
  }
}

.no-plan-banner {
  background: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 8px;
  color: #856404;
  padding: 12px 20px;
  margin: 16px 0;
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
}

.reset-plan-btn {
  background-color: transparent;
  color: $accent;
  border: 1.5px solid $accent;
  border-radius: 4px;
  padding: 0.5em 1em;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.4em;

  &:hover {
    background-color: rgba($accent, 0.08);
  }
}

.template-plan-btn {
  background-color: transparent;
  color: $accent;
  border: 1.5px solid $accent;
  border-radius: 4px;
  padding: 0.5em 1em;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.4em;

  &:hover {
    background-color: rgba($accent, 0.08);
  }
}
</style>

<!-- Non-scoped: the c3 donut title (centre kcal value) is an SVG <text> node
     injected at runtime, so Vue's scoped CSS can't reach it. Scoped to a class
     unique to THIS calendar's day-summary (.calendar-summary-panel) so it
     affects ONLY the right-side day resumen here — not the recipe-detail donut
     and not EditTemplate.vue's own .summary-panel donut. -->
<style lang="scss">
.calendar-summary-panel .c3-chart-arcs-title,
.calendar-summary-panel text.c3-chart-arcs-title {
  font-size: 12px !important;
}
</style>




// WEBPACK FOOTER //
// src/brand/health/layouts/nutritionalPlan/NutritionCalendar.vue